import { Select } from "antd";
import { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { useParams } from "react-router-dom";
import type { RosterPosition } from "~enums/rosterPosition";
import { useSportConfiguration } from "~hooks/useSportConfiguration";

type Props = {
  isEditMode: boolean;
  defaultValue: string;
  onSave: (value: RosterPosition) => Promise<void>;
  disabled: boolean;
};

const PositionEditableColumn = ({ isEditMode, defaultValue, onSave, disabled }: Props) => {
  const [value, setValue] = useState<any | null>(defaultValue);
  const { sport } = useParams();
  const [loading, setLoading] = useState(false);
  const { formatMessage } = useIntl();

  const { rosterPositions } = useSportConfiguration();

  const options = [
    { value: null, label: "-" },
    ...rosterPositions.map((item) => ({
      value: item,
      label: formatMessage({ id: `roster.position.${sport}.${item}` }),
    })),
  ];

  useEffect(() => {
    setValue(defaultValue);
  }, [defaultValue]);

  const handleSave = async (value: RosterPosition) => {
    setValue(value);
    setLoading(true);
    try {
      await onSave(value);
    } finally {
      setLoading(false);
    }
  };

  if (isEditMode) {
    return <Select disabled={loading || disabled} style={{ width: "100%" }} value={value} options={options} onSelect={handleSave} />;
  }

  return <>{defaultValue ? formatMessage({ id: `roster.position.${sport}.${defaultValue}` }) : ""}</>;
};

export default PositionEditableColumn;
